module.exports = __webpack_public_path__ + "static/media/ic_fax_report.d09b2e61.svg";